import BaseError from './BaseError'

export default class ErrorTooManyRequests extends BaseError {
  constructor (message, title = '') {
    super(message, title)
    this.name = 'ErrorTooManyRequests'
    this.status = 429
  }
}
